<!-- <ng-container>
  <app-toast></app-toast>
</ng-container> -->
<ng-container *ngIf="!loadingspiner; else loadingTemplate">
  <ng-container *ngIf="loading">
    <div style="margin-top: 64px;" *ngIf="userdata; else anonymousUser">
    <app-toast></app-toast>
      <app-header (menuToggled)="toggle()"></app-header>
      <mat-drawer-container class="bg-org-color">
        <!-- <ng-content class="sidebar_fixed"> -->
        <mat-drawer class="sidebar_fixed background-header-color border-0" mode="side" [opened]="opened">
          <app-menu-items [menu]="menu"></app-menu-items>
        </mat-drawer>
        <!-- </ng-content> -->
        <mat-drawer-content [class.margin-left]="opened" class="mt-3">
          <router-outlet></router-outlet>
          <ng-container *ngIf="current_route()">
            <div
              *ngIf="userdata?.data.onboarding_status == true && (sub_org_data?.onboarding_status == false || sub_org_data?.onboarding_status == 0)"
              class="onboard_btn_float">
              <button class="onboard_btn" routerLink="/onboarding" mat-flat-button>Onboarding Screen</button>
            </div>
          </ng-container>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
    <!-- <div > -->
    <!-- <app-toast></app-toast> -->
    <!-- <app-layout></app-layout> -->
    <!-- </div> -->
    <ng-template #anonymousUser>
      <app-login></app-login>
      <app-toast></app-toast>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading_container">
      <!-- <mat-progress-spinner class="example-margin" [mode]="mode" [value]="value">
      </mat-progress-spinner> -->
      <div>
        <img src="assets/icons/loading-4802_256.gif" class="logo" alt="loading Logo">
        <!-- <p class="loading_text">Loading...</p> -->
      </div>
  </div>
</ng-template>